import React, { useState, useEffect } from "react";
import SubscribeTable from "../components/SubscribeTable";
import { toast } from "react-toastify";
import api from "../../utilis/api";

const ITEMS_PER_PAGE = 10;

const Subscribe = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handlePageChange = (page) => setCurrentPage(page);

  // Fetch subscribers
  const getSubscribers = async () => {
    try {
      setLoading(true);
      const res = await api.get("/subscribe");
      if (res?.data?.data) {
        setData(res.data.data || []);
      }
    } catch (error) {
      toast.error(error?.message || "Error fetching subscribers");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubscribers();
  }, []);

  // Slice data for current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const pagedData = data.slice(startIndex, endIndex);

  return (
    <div className="flex flex-col w-full gap-4">
      {/* Header */}
      <div className="bg-gray-700 p-3 w-full">
        <h1 className="font-bold text-[1.3rem]">Manage Subscribers</h1>
        <p className="text-sm text-gray-300 mt-1">
          Total Subscribers: {data.length}
        </p>
      </div>

      {/* Table */}
      <div className="p-2 w-full bg-gray-700">
        {loading ? (
          <div className="text-center py-8">
            <p className="text-gray-400">Loading subscribers...</p>
          </div>
        ) : (
          <SubscribeTable
            data={pagedData}
            currentPage={currentPage}
            totalPages={Math.ceil(data.length / ITEMS_PER_PAGE)}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default Subscribe;